import { styled } from "@mui/material/styles";

export const INDICATOR_CLASS = "ModelCard-Indicator";

export const IndicatorContainer = styled("div")(({ theme }) => ({
  fontSize: 14,
  color: theme.palette.secondary[2],
  backgroundColor: "transparent",
  lineHeight: 1,
  height: 20,
  width: 20,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  pointerEvents: "auto",

  "&:hover": {
    backgroundColor: "transparent",
  },
}));
